export const GET_MODELS_URL = 'https://r41n7bn2x8.execute-api.us-east-1.amazonaws.com/v1/model/images/xxx';
export const GET_MODEL_IMAGES_URL = (id, date = '') => 
    `https://r41n7bn2x8.execute-api.us-east-1.amazonaws.com/v1/model/images/${id}?date=${date}`
export const GET_DJT_POSTS = 'https://loif-xxx.s3.us-east-1.amazonaws.com/realDonaldTrump/realDonaldTrump.json';